import { Description } from '@mui/icons-material';
import SegredoJustica from '@mui/icons-material/Lock';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { red } from '@mui/material/colors';
import { action, computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';

import SituacaoAlteracaoMinutaBusiness from '@/dominio/SituacaoAlteracaoMinutaBusiness';

import '../../css/processo.css';
import Configuracao from '../../util/Configuracao';
import ModalCertidao from '../certidao/ModalCertidao';
import LabelNumeroProcesso from '../LabelNumeroProcesso';
import ReactComponent from '../ReactComponent';
import AbrirDialogComposicaoButton from '../shared/AbrirDialogComposicaoButton';
import AtualizarDecisao from './AtualizarDecisao';
import CabecalhoProcessoOperacoesEmLote from './CabecalhoProcessoOperacoesEmLote';
import IconesMagistradosProcesso from './IconesMagistradosProcesso';
import Impedimento from './Impedimento';
import IncluirSustentacaoOral from './IncluirSustentacaoOral';
import ListaSustentacoesOraisEletronicas from './ListarSustentacoesOraisEletronicas';
import ModalConfirmacaoEditarVoto from './ModalConfirmacaoEditarVoto';
import ModalEnviarProcessoPJe from './ModalEnviarProcessoPJe';
import ModalVistaEmMesa from './ModalVistaEmMesa';
import PainelJulgamento from './PainelJulgamento';
import PainelVotacao from './PainelVotacao/PainelVotacao';
import PainelVotacaoPorMateria from './PainelVotacaoPorMateria/PainelVotacaoPorMateria';
import RecarregarCacheServidorDeUmProcesso from './RecarregarCacheServidorDeUmProcesso';
import StatusMinuta from './StatusMinuta';
import VotoAlteradoRelator from './VotoAlteradoRelator';

class FerramentasDetalhesProcesso extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            registro: computed,
            processo: computed,
            origemPJe: computed,
            handleClickNumeroProcesso: action,
            processoDiferenteDoApregoado: computed,
            isProcessoModal: computed,
            composicaoHabilitada: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get processo() {
        return this.registro.processo;
    }

    get origemPJe() {
        return this.registro && this.registro.processo.origem === Configuracao.ORIGEM_PJE;
    }

    handleClickNumeroProcesso = () => {
        let achou = this.store.processosSessao.find(
            (proc) => this.registro.processo.numeroCompleto === proc.processo.numeroCompleto
        );
        if (achou) {
            this.store.processoScroll = this.registro;
        } else {
            this.mensagemStore.abrirMensagemAlerta('Processo não está na lista.');
        }
    };

    get processoDiferenteDoApregoado() {
        return (
            this.sessaoStore.processoApregoado &&
            this.store.processoExpandido &&
            this.sessaoStore.processoApregoado.processo.numeroCompleto !==
                this.store.processoExpandido.processo.numeroCompleto
        );
    }

    get isProcessoModal() {
        return (
            this.store.processoModal &&
            this.store.processoModal.processo.numeroCompleto === this.registro.processo.numeroCompleto
        );
    }

    get composicaoHabilitada() {
        return this.registro.sessaoId;
    }

    handleEditarDispositivo = async () => {
        if (this.salaSessaoStore.confirmarEdicaoVoto) {
            this.salaSessaoStore.abrirModalConfirmacaoEditarVoto();
        } else {
            await this.salaSessaoStore.recuperarUrlEdicaoVoto(this.registro);
            window.open(this.registro.informacoesAdicionais.urlEdicaoVoto);
        }
    };

    render() {
        return (
            <div
                id="divCabecalhoDetalhes"
                style={{ display: 'flex', justifyContent: 'space-between' }}
            >
                {this.renderCabecalhoDetalhes()}
                {this.renderFerramentas()}
            </div>
        );
    }

    renderCabecalhoDetalhes() {
        return this.isProcessoModal ? (
            <CabecalhoProcessoOperacoesEmLote
                consulta
                registro={this.registro}
            />
        ) : (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    maxHeight: '75px',
                    flexWrap: 'wrap',
                    marginBottom: '8px'
                }}
            >
                <div style={{ display: 'flex', flexWrap: 'nowrap', margin: '4px 0px' }}>
                    <Tooltip
                        placement="top"
                        title={
                            <>
                                {this.processoDiferenteDoApregoado && (
                                    <Typography>O processo em análise é diferente do processo apregoado.</Typography>
                                )}
                                <Typography>Selecionar o processo na lista.</Typography>
                            </>
                        }
                    >
                        <Box onClick={this.handleClickNumeroProcesso}>
                            <Typography
                                component="h3"
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    whiteSpace: 'nowrap',
                                    margin: '0px 0px 0px 6px',
                                    cursor: 'pointer'
                                }}
                            >
                                <Typography
                                    component="span"
                                    style={{
                                        fontSize: '17px',
                                        fontWeight: 'bold',
                                        color: this.processoDiferenteDoApregoado
                                            ? 'darkorange'
                                            : this.registro.segredoJustica
                                              ? red[900]
                                              : 'black'
                                    }}
                                >
                                    {this.processo.numeroCompleto}
                                </Typography>
                            </Typography>
                        </Box>
                    </Tooltip>
                    <div>
                        {this.registro.segredoJustica && (
                            <Tooltip
                                title={'SEGREDO DE JUSTIÇA'}
                                placement="top"
                            >
                                <SegredoJustica
                                    style={{
                                        height: '24px',
                                        width: '24px',
                                        marginLeft: '4px',
                                        marginRight: '4px',
                                        color: red[900]
                                    }}
                                />
                            </Tooltip>
                        )}
                    </div>
                </div>
                <div style={{ marginLeft: '4px', marginRight: '4px' }}>
                    <LabelNumeroProcesso
                        exibirIcone
                        habilitarCopiarNumero
                        registro={this.registro}
                    />
                </div>
                <div style={{ marginLeft: '4px' }}>
                    <IconesMagistradosProcesso
                        dense
                        registro={this.registro}
                    />
                </div>
                <div
                    style={{
                        marginLeft: '0px',
                        cursor: 'pointer',
                        display: this.registro.impedimentos ? 'flex' : 'none'
                    }}
                >
                    <Impedimento
                        registro={this.registro}
                        isferramentaDetalhes={true}
                    />
                </div>
                {this.isComponenteHabilitado('PainelVotacao') && (
                    <Box sx={{ ml: 1 }}>
                        <PainelVotacao registro={this.registro} />
                    </Box>
                )}
                {this.isComponenteHabilitado('PainelVotacaoPorMateria') && (
                    <Box sx={{ ml: 1 }}>
                        <PainelVotacaoPorMateria registro={this.registro} />
                    </Box>
                )}
                {this.composicaoHabilitada && (
                    <Box sx={{ ml: 1 }}>
                        <AbrirDialogComposicaoButton registro={this.registro} />
                    </Box>
                )}
            </div>
        );
    }

    renderFerramentas() {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginRight: '10px',
                    justifyContent: 'flex-end',
                    flexWrap: 'wrap',
                    marginBottom: '8px'
                }}
            >
                <VotoAlteradoRelator registro={this.registro} />
                <AtualizarDecisao registro={this.registro} />
                {this.isComponenteHabilitado('Resolucao591CNJ') && (
                    <ListaSustentacoesOraisEletronicas registro={this.registro} />
                )}
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        height: '40px',
                        marginRight: '8px'
                    }}
                >
                    <IncluirSustentacaoOral registro={this.registro} />
                </div>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        height: '40px',
                        marginRight: '8px'
                    }}
                >
                    <ModalVistaEmMesa registro={this.registro} />
                </div>
                <PainelJulgamento registro={this.registro} />
                {this.exibeStatusMinuta() && (
                    <IconButton
                        size="large"
                        style={{
                            height: '40px',
                            padding: '8px',
                            paddingTop: '12px',
                            cursor: this.getCursorStatusMinuta()
                        }}
                    >
                        <StatusMinuta registro={this.registro} />
                    </IconButton>
                )}
                {this.salaSessaoStore.isProcessoApreciado(this.registro) && this.parametroStore.usaCertidao() && (
                    <ModalCertidao registro={this.registro} />
                )}
                {this.registro.processo.origem === Configuracao.ORIGEM_PJE && !this.parametroStore.usaCertidao() && (
                    <>
                        <Tooltip
                            placement="top"
                            title="Editar dispositivo de voto no PJe"
                        >
                            <IconButton
                                size="large"
                                style={{ height: '40px', padding: '8px', color: 'black' }}
                                onClick={this.handleEditarDispositivo}
                            >
                                <Description />
                            </IconButton>
                        </Tooltip>
                        <ModalConfirmacaoEditarVoto registro={this.registro} />
                    </>
                )}
                {this.salaSessaoStore.isProcessoApreciado(this.registro) && (
                    <ModalEnviarProcessoPJe registro={this.registro} />
                )}
                <RecarregarCacheServidorDeUmProcesso registro={this.registro} />
            </div>
        );
    }

    getCursorStatusMinuta() {
        const statusMinuta = SituacaoAlteracaoMinutaBusiness.getStatusMinuta(this.registro);
        return statusMinuta?.onClickEnabled ? 'pointer' : 'default';
    }

    exibeStatusMinuta() {
        return !this.isProcessoModal && SituacaoAlteracaoMinutaBusiness.isMinutaAlterada(this.registro);
    }
}

export default inject('stores')(observer(FerramentasDetalhesProcesso));
